import { render, staticRenderFns } from "./sosMessage.vue?vue&type=template&id=781a5fac&scoped=true&"
import script from "./sosMessage.vue?vue&type=script&lang=js&"
export * from "./sosMessage.vue?vue&type=script&lang=js&"
import style0 from "./sosMessage.vue?vue&type=style&index=0&id=781a5fac&lang=scss&scoped=true&"
import style1 from "./sosMessage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781a5fac",
  null
  
)

export default component.exports